
const Index = () => import(/* webpackChunkName: "department" */ "./index");
const AllDepartments = () => import(/* webpackChunkName: "department" */ "./AllDepartments");

export default [{
  path: 'department',
  name: 'departments-report',
  component: Index,
  redirect: {
    name: 'all-departments'
  },
  children: [{
      path: 'all',
      name: 'all-departments',
      component: AllDepartments,
    }],
}, ]